import {PlantSelect} from '@hconnect/common/components'
import {Env, whiteListByPermission} from '@hconnect/common/hproduce'
import {useLoginContext, useUserContext} from '@hconnect/login'
import {CommonHeader, PageContainer, Shell} from '@hconnect/uikit/src/lib2'
import {useUpmPlantsContext} from '@hconnect/upm'
import React from 'react'
import {generatePath, Navigate, useLocation, useNavigate} from 'react-router'

import {supportedLanguages} from '../../../localization'
import {usePermissionsQuery} from '../../permissions/hooks'
import {ROUTES} from '../../routing'

import {PageSkeleton} from './skeletons'

export const PagePlantSelect: React.FC = () => {
  const {pathname} = useLocation()
  const {logout} = useLoginContext()
  const {loggedUser} = useUserContext()
  const {data: permissions, isLoading} = usePermissionsQuery()
  const navigate = useNavigate()
  const upmPlants = useUpmPlantsContext({isInitialLoad: true})

  if (isLoading || !upmPlants) {
    return <PageSkeleton />
  }

  const whiteList = whiteListByPermission(
    process.env.REACT_APP_STAGE as Env,
    permissions || [],
    upmPlants
  )
  const plants = whiteList.optionsPerApp.Settings || []

  if (plants.length === 0) {
    return <Navigate to={ROUTES.BASE.NOT_AUTHORIZED.path} replace />
  }

  if (plants.length === 1) {
    return <Navigate to={generatePath(ROUTES.BASE.PLANT_SELECTOR.PLANT.path, { plantCode: plants[0].plantId })} replace />
  }

  return (
    <Shell
      isResponsive
      boxed={false}
      header={
        <CommonHeader
          appName="Settings"
          upmPlants={upmPlants}
          env={process.env.REACT_APP_STAGE as Env}
          permissions={permissions ?? []}
          navigate={navigate}
          locationPath={pathname}
          supportedLanguages={supportedLanguages}
          user={{...loggedUser, name: loggedUser?.name ?? undefined}}
          onLogout={() => void logout()}
        />
      }
    >
      <PageContainer>
        <PlantSelect plants={plants} />
      </PageContainer>
    </Shell>
  )
}
